export const CURRENCY_RATE = 100;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatCurrencyOnChange = (onChangFunction: (...event: any[]) => void): ((...event: any[]) => void) => {
    return (event) =>
        onChangFunction(event.target.value ? parseInt(event.target.value, 10) * CURRENCY_RATE : undefined);
};
